export const URL = '/v2/pms/accomodations/:accomId/media/batch_undelete/'

export type Req = {
  ids: number[]
}

export type Resp = any